<!-- 商品主数据新增 -->
<template>
  <div class="addGoods">
    <div class="topForm">
      <el-form :model="approveData" ref="topForm">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="商品编码" prop="code" label-width="90px">
              <el-input v-model="approveData.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="申请原因" prop="type" label-width="90px">
              <el-input v-model="approveData.type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label=" " prop="reason" label-width="0">
              <el-input v-model="approveData.reason"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- tab页 -->
    <el-tabs class="addGoodsTabs" type="border-card">
      <!-- 物产化工主数据 -->
      <el-tab-pane label="物产化工主数据">
        <wchg-data ref="wchgData" :isEdit="false" />
      </el-tab-pane>
      <!-- 公司自有数据 -->
      <el-tab-pane label="公司自有数据">
        <company-data ref="companyData" :isEdit="false" />
      </el-tab-pane>
      <!-- 系统映射表 -->
      <el-tab-pane label="系统映射表">
        <mapping-data
          ref="mappingData"
          :isEdit="false"
          :dataMapping="goodsDetail.systemMaps || []"
          v-if="goodsDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 底部按钮 -->
    <div class="bottomBtn">
      <el-button class="saveBtn" type="primary" @click="save">保存</el-button>
      <el-button style="width: 100px" type="primary">提交</el-button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import wchgData from './components/wchgData'; // 物产化工主数据
  import companyData from './components/companyData'; // 公司自有数据
  import mappingData from './components/mappingData'; // 系统映射表

  export default {
    name: 'addGoods',
    components: {
      wchgData,
      companyData,
      mappingData,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      return {
        approveData: {
          code: '',
          type: '',
          reason: '',
        },
      };
    },
    mounted() {
      // console.log(this.userInfo)
    },
    methods: {
      save() {
        this.$refs.baseData.clearFormData();
      },
    },
  };
</script>

<style scoped>
  .addGoods {
    padding: 10px;
    background-color: #fff;
  }
  .addGoods .bottomBtn {
    text-align: center;
    padding: 20px;
  }
  .addGoods .bottomBtn .saveBtn {
    width: 100px;
    background-color: #6abefd;
    border: 1px solid #6abefd;
  }
</style>
